import FeedbackHeadline from "ds/components/Feedback/Headline";
import FeedbackWrapper from "ds/components/Feedback/Wrapper";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type BillingUpgradeAvailableBoxProps = {
  title: string;
  items: string[];
};

const BillingUpgradeAvailableBox = ({ title, items }: BillingUpgradeAvailableBoxProps) => {
  return (
    <FeedbackWrapper type="banner" variant="promo" fullWidth>
      <FeedbackHeadline>{title}</FeedbackHeadline>
      {items.length === 1 && (
        <Typography tag="p" variant="p-body3">
          {items[0]}
        </Typography>
      )}
      {items.length > 1 && (
        <ul className={styles.list}>
          {items.map((item) => (
            <li key={item}>
              <Typography tag="span" variant="p-body3">
                {item}
              </Typography>
            </li>
          ))}
        </ul>
      )}
    </FeedbackWrapper>
  );
};

export default BillingUpgradeAvailableBox;
